import { observer } from "mobx-react-lite";
import { Button, Header, Label, Segment } from "semantic-ui-react";
import axios from "axios"

import { Link } from "react-router-dom";
import { Form, Formik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";

// import Button from 'react-bootstrap/Button';

import MyTextInput, { MyTextInputConvD, MyTextInputConv } from "../../../app/common/form/MyTextInput";
import { MySelectInput, MySelectInputControl } from '../../../app/common/form/MySelectInput';

import React, { useEffect, useState } from "react";

import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import "../src/css/convenios.css";

const apiURL: any = process.env.REACT_APP_API_URL + '/SGTDependencias';
let entidad: any = "";

export default observer(function AddModalDependencias(props: { show: any, onHide: any, valor: any }) {

    const validationSchema = Yup.object({
        dependencia: Yup.string()
            .required('Requerido')
            .min(10, 'Describe bien tu solicitud.')
            .max(90, 'Ingresa una descripción mas corta')
    });

    function ExitVal() {
        Swal.fire({
            position: "center",
            icon: "success",
            title: "Dependencia Agregada",
            text: 'La dependencia se ha agregado satisfactoriamente, ahora debes seleccionarla en el listado de dependencias para continuar con la creacion del código.',
            showConfirmButton: false,
            timer: 3500,
        });

    };

    entidad = props.valor;

    const getSubmitHandler = (saving: any) => (values: any, formik: any) => {
        const endpoint = saving
            ? apiURL
            : apiURL;
        return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: { "Content-Type": "application/json" }
        }).then(function (r) {
            if (r.status == 200) {
                return ExitVal()
            } else {}
        });
    };

    return (
        <Modal
            {...props}
            size="lg"
            className="modal-add-dep-content"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Formik
                validationSchema={validationSchema}                
                initialValues={{
                    dependencia: "",
                    sgtEntidadIdEntidad: entidad
                }}
                
                onSubmit={(values, { setSubmitting }) => {
                    getSubmitHandler(values);
                    setSubmitting(true);
                }}
            >
                {formik => (
                    <>
                        <Form>
                            <Modal.Header closeButton >
                                <Modal.Title id="contained-modal-title-vcenter">
                                    Agregar nueva dependencia
                                </Modal.Title>
                            </Modal.Header>

                            <Modal.Body className="modal-dep-area">

                                <Row>
                                    <Col>
                                        <MyTextInputConv
                                            name="dependencia"
                                            label="Ingresa el nombre de la nueva dependencia:"
                                            type="input" id="dependencia"
                                            placeholder={"Ej: Dirección de Recursos humanos"}
                                        />
                                    </Col>
                                </Row>

                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="primary" disabled={!(formik.isValid && formik.dirty)} onClick={event => getSubmitHandler({ saving: true, enableReinitialize:true, validationSchema })(formik.values, formik.isValid)}>Guardar</Button>
                            </Modal.Footer>
                        </Form>


                    </>

                )}
            </Formik>

        </Modal>
    );
})